<template>
  <div class="inline-flex items-center relative filter-menu-container">
    <custom-input 
      :icon="icon" 
      :show-icon="true" 
      v-model="searchQuery" 
      @keyup.enter="$emit('search', searchQuery)" 
      type="text" 
      :placeholder="placeholder" 
      class="w-56 text-sm" 
      @iconClicked="$emit('search', searchQuery)" 
      :icon-clickable="true" 
      :show-error="false"
      :show-clear-button="searchQuery.length > 0"
    />
    <span v-if="showText" class="ml-2 text-sm">{{ text }}</span>
  </div>
</template>

<script setup>
import { ref, watch, onBeforeUnmount } from 'vue'
import CustomInput from '@/components/base/inputs/VInput.vue'

const props = defineProps({
  icon: { type: String, default: 'search' },
  placeholder: { type: String, default: 'Search...' },
  showText: { type: Boolean, default: false },
  text: { type: String, default: 'Search' },
  initialQuery: { type: String, default: '' },
})

const emit = defineEmits(['search'])

// Local search query with two-way binding
const searchQuery = ref(props.initialQuery)

// Watch for changes to emit search event after a small delay
let debounceTimeout = null
watch(searchQuery, (newValue) => {
  // Clear previous timeout
  if (debounceTimeout) {
    clearTimeout(debounceTimeout)
  }
  
  // Set new timeout to debounce search input
  debounceTimeout = setTimeout(() => {
    emit('search', newValue)
  }, 300) // 300ms debounce time
})

// Watch for changes to initialQuery from parent
watch(() => props.initialQuery, (newValue) => {
  if (newValue !== searchQuery.value) {
    searchQuery.value = newValue
  }
})

// Clear search on component unmount
onBeforeUnmount(() => {
  if (debounceTimeout) {
    clearTimeout(debounceTimeout)
  }
})
</script>
